<template>
	<div>
		<div v-for="room in items" :key="room.ID" class="room row contentblock">
			<div class="columns column6 col-image">
				<div v-if="room.images">
					<a
						:data-src="room.images[0].image"
						:data-fancybox="`gallery-${room.ID}`"
						:data-caption="room.images[0].imageAlt"
						:title="room.images[0].imageAlt"
					>
						<picture>
							<source
								v-if="room.images[0].imageWebp"
								:srcset="room.images[0].imageWebp"
								type="image/webp"
							/>
							<source :srcset="room.images[0].image" />
							<img :src="room.images[0].image" :alt="room.images[0].imageAlt" loading="lazy" />
						</picture>
					</a>
				</div>
			</div>
			<div class="columns column6 col-content">
				<div class="contentblock-content align-left">
					<h2>{{ room.header }}</h2>
					<div class="room-icon">
						<div v-if="room.pax">
							<font-awesome-icon :icon="`fas fa-users`" size="1x" />
							<span>{{ room.pax }}</span>
						</div>
						<div v-if="room.surface">
							<font-awesome-icon :icon="`fas fa-ruler-combined`" size="1x" />
							<span>{{ room.surface }}</span>
						</div>
					</div>
					<div v-parse-links v-html="room.content" />
					<book-button v-if="type === 'rooms'" class="button cta">
						{{ $t('bookThisRoom') }}
					</book-button>
					<nuxt-link v-else :to="localePath('meeting-form', locale)" class="button cta">
						{{ $t('buttonRequestInfo') }}
					</nuxt-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
const { locale } = useI18n();

import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

defineProps({
	items: { type: Array, default: () => [] },
	filter: { type: String, default: 'showAll' },
	type: { type: String, default: 'rooms' },
});

onMounted(() => {
	Fancybox.bind('[data-fancybox]', {});
});
</script>

<style lang="scss" scoped>
.contentblock {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	padding: 0;
	margin: 40px auto;
	position: relative;

	&:nth-child(odd) {
		flex-direction: row-reverse;

		.col-image {
			left: 0;
			right: auto;
		}

		.col-content {
			padding: 25px 0 25px 10%;
		}
	}

	.columns:first-child {
		padding: 0;
	}

	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}

	.col-content {
		padding: 40px 8% 40px 0;
		background: var(--secondary-background-color);
		position: relative;
		z-index: 1;
		width: 53%;
	}

	.col-image {
		position: absolute;
		top: 50px;
		right: 0;
		bottom: 50px;
		width: 57%;
		z-index: 2;

		div {
			width: 100%;
			height: 100%;
		}
	}

	.contentblock-content {
		padding: 75px;
		min-height: 420px;
	}
}

.room-icon {
	display: flex;
	flex-flow: row wrap;
	justify-content: flex-start;
	align-items: center;
	margin: 20px 0;

	div {
		margin: 5px 18px 5px 0;
	}

	svg {
		font-size: 16px;
		margin: 0 3px 0 0;
	}
}

@media (max-width: 1080px) {
	.contentblock {
		.col-image {
			width: 100%;
			position: relative;
			inset: auto;
		}

		.col-content {
			padding: 0 !important;
			width: 100%;
			margin: 0 auto;
		}

		.contentblock-content {
			padding: 50px;
			min-height: auto;
		}
	}
}

@media (max-width: 580px) {
	.contentblock {
		margin-bottom: 25px;

		.contentblock-content {
			padding: 35px;
		}
	}
}
</style>
